import { csrfManager } from "../../../../../../lib-sat/csrf/csrf-manager";
import { apiRequestManager } from '../../../../../../lib-sat/api/api-request-manager';
import { pageNotification } from "../../../../../../qaamgo/helper/notify";
import {satGlobals} from "../../../../../sat/helper/sat-globals";
import axios from 'axios';

class FeedbackManager {
    constructor() {
        this.showError = false;
        this.loading = false;
        this.submitted = false;
    }

    setSubmit(submit) {
      this.submitted = submit;
    }

    async submitFeedback(currentJob, rating, message) {
        if (!rating) {
            this.showError = true;
            return;
        }

        this.loading = true;

        const csrfToken = await csrfManager.getCsrfFeedback();
        let feedbackData = {
            operation: 'aicreatorstudio',
            _csrf: csrfToken,
        };

        feedbackData.job_id = currentJob.apiJob?.id;
        feedbackData.job_status = currentJob.apiJob?.status.code;
        feedbackData.rating = rating;
        feedbackData.feedback = message;

        apiRequestManager
            .post('/api/feedback', feedbackData)
            .then(() => {
                this.showError = false;
                this.loading = false;
                this.submitted = true;
            })
            .catch(() => {
                pageNotification.showGenericErrorMessage();
            });
    }

    async submitRating(currentJob, rating, operation, payload = null) {

        const csrfToken = await csrfManager.getCsrfFeedback();
        let feedbackData = {
            operation: operation,
            _csrf: csrfToken,
        };

        feedbackData.job_id = currentJob.apiJob?.id;
        feedbackData.rating = rating;
        feedbackData.additional_data = payload;

        await axios.post(satGlobals.getApiUrl('/api/feedback_rating'), feedbackData, {withCredentials: true});
    }
}

export default new FeedbackManager();
